import React from 'react'
import logo from 'Media/Logo-01.jpg'

const LoadingLogo = () => {
    return (
        <div
            className="lazy-load-component d-flex flex-column justify-content-center align-items-center"
            style={{ height: '100vh', width: '100vw' }}
        >
            <img src={logo} alt="Logo" style={{ width: '100px', marginBottom: '1rem' }} />
            <i className="bx bx-loader bx-spin" style={{ fontSize: '3rem' }} />
        </div>
    )
}

export default LoadingLogo
